<style lang="scss" scoped>
.main-container {
  min-height: 100vh;
  background-color: #ffffff;
  padding-top: 10px;

  .split-line {
    width: 702px;
    height: 2px;
    margin: 0 auto;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(#1d1d1d, 0.06);
    // test
  }

  .operate-container {
    // width: 702px;
    z-index: 10;
    width: 100%;
    background: #ffffff;
    padding: 10px 24px 10px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;

    // left: 24px;
    .sale-btn,
    .apprasial-btn {
      height: 72px;
      width: 340px;
      box-sizing: border-box;
      border: 2px solid #2a2a30;
      border-radius: 2px;
      color: #2a2a30;
      font-size: 28px;
      line-height: 72px;
      text-align: center;
    }

    .apprasial-btn {
      color: #ffffff;
      background-color: #2a2a30;
      border: none;
      border-radius: 2px;
    }
  }

  .tab-container {
    height: 93px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    background-color: #ffffff;
    z-index: 1000;

    .tab-item {
      flex: 1;
      font-size: 28px;
      color: #999999;
      text-align: center;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      &.active {
        color: #1d1d1d;

        &::after {
          content: '';
          display: block;
          position: absolute;
          width: 52px;
          height: 4px;
          background-color: #1d1d1d;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .bottom-area {
    height: 120px;
  }
}
</style>

<template>
  <div class="main-container">
    {{ dataMsg }}
    <!-- 商品轮播图 -->
    <banner :bannerList="bannerList" :logId="logId" :type="type"></banner>
    <!-- 相似款式 -->
    <!-- <similar-design v-if="similarList.length > 0 && totalSimilar > 0" class="design" :skcInfo="skcInfo" :similarList="similarList" :totalSimilar="totalSimilar" :skcList="skcList" ></similar-design> -->
    <!-- <div class="split-line"></div> -->
    <!-- <similar-design v-if="similarList.length > 0 && totalSimilar > 0" class="design" :skcInfo="skcInfo"
      :similarList="similarList" :totalSimilar="totalSimilar" :skcList="skcList"></similar-design>
    <div class="split-line"></div> -->
    <!-- 品牌详情 -->
    <brand-detail :brandInfo="brandInfo"></brand-detail>
    <div class="split-line"></div>
    <!-- tab栏效果 -->
    <!-- <div class="tab-container">
      <div v-if="compareList && compareList.length > 0" :class="`tab-item${curTab===0 ? ' active': ''}`" @click="scrollTo(0)">行情</div>
      <div :class="`tab-item${curTab===1 ? ' active': ''}`" @click="scrollTo(1)">百科</div>
      <div :class="`tab-item${curTab===2 ? ' active': ''}`" @click="scrollTo(2)">交易{{`${tradeCount > 0 ? '('+ tradeCount+ ')' : '' }`}}</div>
    </div> -->
    <!-- <div id="content1"></div> -->
    <!-- 价格比较 -->
    <!-- <compare v-if="compareList.length > 0" :compareList="compareList" :compareInfo='compareInfo'></compare> -->
    <div id="content2"></div>
    
    <!-- 概述 -->
    <overview :overViewObj="overViewObj"></overview>
    <!-- 价格分析 -->
    <price-analysis v-if="stateProps.length > 0" :stateProps="stateProps"></price-analysis>
    <!-- 官方价 -->
    <official-price v-if="officialList.length > 0" :officialList="officialList"></official-price>
    <!-- 在售商品 -->
    <!-- <onsale v-if="onSaleList.length > 0" :onSaleCount="onSaleCount" :onSaleList='onSaleList' :skc="skc"></onsale> -->
    <div id="content3"></div>

    <!-- 交易记录（暂时不需要） -->
    <!-- <trade-record v-if="tradeList.length > 0 && tradeCount > 0" :tradeCount="tradeCount" :tradeList="tradeList" :skcInfo="skcInfo"></trade-record> -->
    <!-- 为您推荐 -->
    <!-- <recommend v-if="recommendList.length > 0" :recommendList="recommendList"></recommend> -->
    <!-- 售卖按钮 -->
    <!-- <div v-if="skcInfo.brandId" class="operate-container">
      <div class="sale-btn" @click="goSale">
        我想卖
      </div>
      <div class="apprasial-btn" @click="goIndentify">
        去鉴别
      </div>
    </div> -->
    <div class="bottom-area"></div>
  </div>
</template>

<script>
import Banner from './components/banner';
import SimilarDesign from './components/similar-design';
import BrandDetail from './components/brand-detail';
import Compare from './components/compare';
import OfficialPrice from './components/official-price';
import Overview from './components/overview';
import Onsale from './components/onsale';
import TradeRecord from './components/trade-record';
import Recommend from './components/recommend';
import priceAnalysis from './components/price-analysis.vue'
// import {isTestEnv} from './../../common/constant'
import { H5PAGES_TARO_CONFIG } from './../../common/navigate-config'

import { fetchSkcInfo, fetchSimilarList, fetchMallProduct, fetchTradeList, fetchResult, fetchSkcInfoNew } from './../../common/api/ai-picture'

export default {
  components: {
    Banner,
    SimilarDesign,
    BrandDetail,
    Compare,
    OfficialPrice,
    Overview,
    Onsale,
    TradeRecord,
    Recommend,
    priceAnalysis
  },
  data() {
    return {
      dataMsg: '',
      type: '0', // 进入包包百科的方式 ： 0:携带数据进来的， 1： 不携带数据，需要自行查询的（skc、brandId、kindId）
      bannerList: [],
      logId: '',
      similarList: [],
      totalSimilar: 0,
      compareList: [],
      officialList: [],
      overViewObj: {},
      stateProps: [],
      brandInfo: {},
      onSaleList: [],
      onSaleCount: 0,
      recommendList: [],
      tradeList: [],
      tradeCount: 0,
      skc: '',
      skcList: [],
      skcInfo: {},
      compareInfo: {},
      brandLogo: '',
      curTab: 1
    }
  },
  methods: {
    // 查询相似列表
    getSimilarList(skc, seriesId, brandId) {
      // fetchSimilarList({ skc, seriesId, brandId, pageSize: 20, source: '1', skcList: [] })
      fetchSimilarList({ skc, seriesId, brandId, pageSize: 20, source: '1', skcList: this.skcList })
        .then(result => {
          if (result && result.errorCode === 0) {
            this.totalSimilar = result.count;
            this.similarList = result.skcSimilarItem;
          } else {
            this.totalSimilar = 0;
            this.similarList = [];
          }
        })
    },
    // 查询商品列表
    getMallProductlist(skc) {
      // fetchMallProduct({ skc, pageSize: 20 })
      fetchMallProduct({ pageSize: 20, pageNum: 1, skc, sort: '-recommendation_score' })
        .then(result => {
          if (result && result.errorCode === 0) {
            this.onSaleList = result.searchInfo;
            this.onSaleCount = result.total;
          }
        })
    },
    // 查询推荐商品列表
    getRecommendlist() {
      fetchMallProduct({ pageSize: 20, pageNum: 1 })
        .then(result => {
          if (result && result.errorCode === 0) {
            this.recommendList = result.searchInfo;
          }
        })
    },
    // 处理数据
    dealData(data) {
      const {
        mainPic = [],
        kindId = 0,
        brandId = 0,
        seriesId = 0,
        description = '', // 商品描述
        brandEnName = '', // 品牌名称
        seriesName = '', // 系列名称
        productName = '', // 商品名称
        onSaleCount = 0, // 在售数量
        skc = '', // skc
        colorName = '', // 颜色
        productCode = '', // 货号
        measurement = '', // 尺寸
        releasePrice = '', // 发售价格（官方价）
        releaseDate = '', // 发售日期
        origin = '', // 产地
        forPeople = '', // 适用人群，0：女， 1： 男
        materialStr = '', // 材质
        overflowPrice = '', // 溢价
        similarCount = 0, // 相似款式总数
        pidSimilarItem = [],
        worldPriceItem = [],
        productNewsItem = [],
        skcList = [],
        newsDetails = [],
        sku,
        brandLogo = '',
        newsPrice = [] // 价格分析
      } = data || {};
      this.skc = skc;
      this.brandLogo = brandLogo;
      this.skcList = skcList;
      this.skcInfo = { skc, mainPic, kindId, brandId, seriesId, brandEnName, productName, seriesName, colorName, sku };
      // 立刻查询当前skc的相似款式
      this.getSimilarList(skc, seriesId, brandId);
      // this.getSimilarList({ skc: '8661457614', brandId: '106', seriesId: '1159' })
      // 给轮播图和brand信息赋值
      this.bannerList = mainPic;
      this.brandInfo = { brandEnName, productName, }
      this.stateProps = newsPrice.filter(item => item.price)
      this.overViewObj = {
        skc, brandId, kindId, brandEnName, seriesName, colorName, measurement, productCode, releaseDate, releasePrice, origin, materialStr, forPeople: forPeople === '0' ? '女' : (forPeople === '1' ? '男' : ''), description
      };
      this.stateProps = newsPrice.filter(item => item.price)
      this.compareInfo = { releasePrice, overflowPrice, }
      // 全球
      this.officialList = worldPriceItem;
      // 查询在售商品
      this.getMallProductlist(skc);
      // 查询推荐
      this.getRecommendlist();
      // 查询交易记录；
      fetchTradeList({ pageSize: 10, pageNum: 1, skc, state: '8' })
        .then(result => {
          this.tradeList = result.itemList;
          this.tradeCount = result.totalCount;
        })

      this.compareList = productNewsItem.filter(item => { return !item.isNone });
      if (this.compareList && this.compareList.length > 0) {
        this.curTab = 0;
      }

      this.compareList.forEach(item => {
        const obj = {};
        const dateSet = new Set();
        if (!item.graphPrice) {
          item.graphPrice = [];
        }
        item.graphPrice.forEach(price => {
          if (!obj[price.source]) {
            obj[price.source] = []
          }
          obj[price.source].push(price.price / 100 || 0);
          const date = new Date(price.time / 1000000);
          dateSet.add((date.getMonth() + 1) + '-' + date.getDate());
        })
        const keys = Object.keys(obj);
        item.dateList = Array.from(dateSet).reverse();
        item.dataList = [];
        keys.forEach(key => {
          // 按照日期
          item.dataList.push({
            data: obj[key].reverse(),
            source: key,
          });
        })
      });
    },
    goSale() {
      // let obj = {
      //   // sku: this.skcInfo.sku,
      //   color: this.skcInfo.colorName,
      //   measurement: this.skcInfo.measurement,
      //   size: this.skcInfo.sizeName,
      //   productName: this.skcInfo.productName,
      //   imageUrl: encodeURIComponent(this.skcInfo.mainPic[0])
      // }
      // if (window.isWXWebView) {
      //   // wx.miniProgram.postMessage({data: ''})
      //   wx.miniProgram.navigateTo({ url: `/subPackages/goods-supply/release/index?obj=${JSON.stringify(obj)}&brandID=${this.skcInfo.brandId}&kindID=${this.skcInfo.kindId}&name=${this.skcInfo.brandEnName}` });
      // }

      if (window.isWXWebView) {
        // wx.miniProgram.postMessage({data: ''})
        wx.miniProgram.switchTab({ url: `/pages/sell/index` });
      } else {
        H5PAGES_TARO_CONFIG.toSaleIndex();
        // window.location.href = isTestEnv ? "https://baoh5test.turingsenseai.com/h5/#/pages/sell/index" : "https://baoh5.turingsenseai.com/h5/#/pages/sell/index"

        // this.$$toast('暂未实现，敬请期待~')
      }
    },
    goIndentify() {
      if (window.isWXWebView) {
        wx.miniProgram.navigateTo({ url: `/pages/identify/guide?op=identify&key=${this.skcInfo.brandId}&name=${this.skcInfo.brandEnName}&categoryEnum=1&image=${this.brandLogo}` });
      } else {
        H5PAGES_TARO_CONFIG.toIndentify();
        // window.location.href = isTestEnv ? "https://baoh5test.turingsenseai.com/h5/#/common/select/category?op=identify" : "https://baoh5.turingsenseai.com/h5/#/common/select/category?op=identify"
      }
    },
    listenScroll() {
      setTimeout(() => {
        const tabHeight = (document.body.offsetWidth / 750) * 92;
        // const topHeight1 = this.getElementTop(document.getElementById('content1')) - tabHeight;
        const topHeight2 = this.getElementTop(document.getElementById('content2')) - tabHeight;
        const topHeight3 = this.getElementTop(document.getElementById('content3')) - tabHeight;
        window.addEventListener('scroll', (e) => {
          let scrollTop = document.scrollingElement.scrollTop || document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
          if (scrollTop < topHeight2) {
            if (this.compareList && this.compareList.length > 0) {
              this.curTab = 0;
            } else {
              this.curTab = 1;
            }
          } else if (scrollTop >= topHeight2 && scrollTop < topHeight3) {
            this.curTab = 1;
          } else {
            this.curTab = 2;
          }
        })
      }, 2000)
    },
    // 获取一个元素距离顶部的高度
    getElementTop(elem) {
      var elemTop = elem.offsetTop; // 获得elem元素距相对定位的父元素的top
      elem = elem.offsetParent; // 将elem换成起相对定位的父元素
      while (elem != null) { // 只要还有相对定位的父元素 
        /* 获得父元素 距他父元素的top值,累加到结果中 */
        elemTop += elem.offsetTop;
        // 再次将elem换成他相对定位的父元素上;
        elem = elem.offsetParent;
      }
      return elemTop;
    },
    // 滚动到指定位置
    scrollTo(index) {
      const tabHeight = (document.body.offsetWidth / 750) * 92;
      setTimeout(() => { this.curTab = index; }, 100)
      switch (index) {
        case 0: {
          const topHeight = this.getElementTop(document.getElementById('content1'));
          if (document.scrollingElement && topHeight) {
            document.scrollingElement.scrollTop = topHeight - tabHeight;
          } else {
            document.getElementById('content1').scrollIntoView(tabHeight)
          }
          break;
        }
        case 1: {
          const topHeight = this.getElementTop(document.getElementById('content2'));
          if (document.scrollingElement && topHeight) {
            document.scrollingElement.scrollTop = topHeight - tabHeight;
          } else {
            document.getElementById('content2').scrollIntoView(tabHeight)
          }
          break;
        }
        case 2: {
          const topHeight = this.getElementTop(document.getElementById('content3'));
          if (document.scrollingElement && topHeight) {
            document.scrollingElement.scrollTop = topHeight - tabHeight;
          } else {
            document.getElementById('content3').scrollIntoView(tabHeight)
          }
          break;
        }
      }
    }
  },
  watch: {
    $route() {
      // Object.assign(this.$data, this.$options.data());
      // const data = this.$route.query.data ? JSON.parse(this.$route.query.data) : {};
      const params = this.$route.query.params ? JSON.parse(this.$route.query.params) : {};
      // const type = this.$route.query.type;
      this.logId = this.$route.query.logId;
      // this.type = type;
      fetchSkcInfoNew(params || {})
        .then(result => {
          if (result && result.errorCode === 0) {
            this.dealData(result.holmesResult[0]);
            // TODO 要实现未识别的跳转页面（这种情况理论上不会出现，所以不做处理）
          }
        })
      // if (type === '0') {
      //   this.dealData(data[0]);
      // } else if (type === '1') {
      //   params.kindID = params.kindId;
      //   params.brandID = params.brandId;
      //   fetchSkcInfoNew(params || {})
      //     .then(result => {
      //       if (result && result.errorCode === 0) {
      //         this.dealData(result.holmesResult[0]);
      //       // TODO 要实现未识别的跳转页面（这种情况理论上不会出现，所以不做处理）
      //       }
      //     })
      // }
    },
  },
  mounted() {
    // Object.assign(this.$data, this.$options.data());
    // const data = this.$route.query.data ? JSON.parse(this.$route.query.data) : {};
    const params = this.$route.query.params ? JSON.parse(this.$route.query.params) : {};
    // const type = this.$route.query.type;
    this.logId = this.$route.query.logId;
    // this.type = type;

    fetchSkcInfoNew(params || {})
      .then(result => {
        if (result && result.errorCode === 0) {
          this.dealData(result.holmesResult[0]);
          // TODO 要实现未识别的跳转页面（这种情况理论上不会出现，所以不做处理）
        }
      })

    // type=0代表是从识图页面带数据过来的，type=1代表是从其他各入口进入，此时需要携带params参数（brandId,kindId,skc）
    // if (type === '0') {
    //   this.dealData(data[0]);
    // } else if (type === '1') {
    //   params.kindID = params.kindId;
    //   params.brandID = params.brandId;
    //   fetchSkcInfoNew(params || {})
    //     .then(result => {
    //       if (result && result.errorCode === 0) {
    //         this.dealData(result.holmesResult[0]);
    //       // TODO 要实现未识别的跳转页面（这种情况理论上不会出现，所以不做处理）
    //       }
    //     })
    // }
    // this.listenScroll();
  },
  created() {
  }
}
</script>
